<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.tab" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('notVerified')"></b-tab>
          <b-tab :title="$t('verified')"></b-tab>
          <b-tab :title="$t('locked')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select v-if="!client" class="mr-1 mb-1" :model="filterFormModel"  attribute="client" @change="search" :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>

      <!-- c-paging -->
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-4">Email sender</div>
            <div class="col-lg-2 text-center">{{ $t('status') }}</div>
            <div class="col-lg-3"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <div v-if="item.client">
                <div><b>{{ $t("companyName") }}: </b>{{ item.client.companyName }}</div>
                <div><b>{{ $t("domain") }}: </b>{{ item.client.domain }}</div>
              </div>
            </div>
            <div class="col-lg-4">
              <div><b>{{ $t("name") }}: </b>{{ item.name ? item.name : 'No name' }}</div>
              <div><b>{{ $t("email") }}: </b>{{ item.email }}</div>
            </div>
            <div class="col-lg-2 text-center">
              <div>
                <label v-if="item.verifiedTime" class="badge badge-success">{{$t('verified')}}</label>
                <label v-else class="badge badge-warning">{{$t('notVerified')}}</label>
              </div>
              <div v-if="item.lockTime">
                <label class="badge badge-danger">{{$t('locked')}}</label>
              </div>
            </div>
            <div class="col-lg-3 text-right">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
                    <button @click="lock(item)" type="button" class="btn btn-sm mr-1" :class="item.lockTime ? 'btn-success' : 'btn-danger'">
                      <font-awesome-icon icon="lock"/>&nbsp;{{ item.lockTime ? $t('unlock') : $t('lock') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm mr-1 btn-danger">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "../../components/ClientSelect";
import _ from 'lodash';

export default {
  props: {
    host: Object,
    client: Object
  },
  components: {
    ClientSelect
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/email-sender',
      defaultFilterFormModel: {
        client: this.client ? this.client._id : null
      },
    }
  },
  methods:{
    search: _.debounce(function () {
                this.filterFormModel.page = 1;
                this.load();
            }, 200),
    lock(item) {
      let confirmText = this.$t('lockConfirm');
      let successText = this.$t('lockSuccess');
      let failText = this.$t('lockFail');
      if (item.lockTime) {
        confirmText = this.$t('unlockConfirm');
        successText = this.$t('unlockSuccess');
        failText = this.$t('unlockFail');
      }
      this.$swal({
        text: confirmText,
        icon: 'info',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/lock/' + item._id).then(response => {
            if (response.data) {
              this.$swal({
                text: successText,
                icon: 'success'
              });
              this.load();
            } else {
              this.$swal({
                text: failText,
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      })
    }
  },
  i18n: {
    messages: {
      en: {
        lock: 'Lock',
        unlock: 'Unlock',
        lockConfirm: 'Are you sure to lock this email sender?',
        lockSuccess: 'Email sender locked!',
        lockFail: 'Fail to lock email sender!',
        unlockConfirm: 'Are you sure to unlock this email sender?',
        unlockSuccess: 'Email sender unlocked!',
        unlockFail: 'Fail to unlock email sender!'
      },
      vi: {
        lock: 'Khoá',
        unlock: 'Mở khoá',
        lockConfirm: 'Bạn có chắc muốn khoá sender này?',
        lockSuccess: 'Khoá sender thành công!',
        lockFail: 'Khoá sender thất bại',
        unlockConfirm: 'Bạn có chắc muốn mở khoá sender này?',
        unlockSuccess: 'Mở khoá thành công!',
        unlockFail: 'Mở khoá thất bại!'
      }
    }
  }
};
</script>